export default __webpack_public_path__ + "static/math.and.magic-ba1fad30fda38becb7dc4e9600e6c836.jpg";